import React from 'react';
import { InvoiceModelWithInvoiceItems, ReservationModelWithModelsIncluded, RoomInfoMap } from '@common/modelDefinition';
import useStore from '@data/state/zustand';

interface TerminalHeaderProps {
    invoice: InvoiceModelWithInvoiceItems;
    translate: any;
}

const TerminalHeader = (props: TerminalHeaderProps) => {
    const { invoice, translate } = props;

    const reservations: ReservationModelWithModelsIncluded[] = useStore((appState: any) => appState.model.Reservation);
    const roomInfoMap: RoomInfoMap =  useStore.getState().map.RoomInfo()

    const reservation = reservations && reservations?.find((r: ReservationModelWithModelsIncluded) => r.id === invoice.reservationId);

    if (!reservation) {
        return null;
    }
    const { roomInfoId } = reservation;
    const room = roomInfoMap && roomInfoMap?.[roomInfoId];

    return (
        <div className="d-flex justify-content-between mt-3 p-2">
            <div className="p-2">
                <small>
                    <div>
                        <b>{translate('Reservation id')}</b>: {reservation.id}
                    </div>

                    <div>
                        <b>{translate('Room')}</b>: {room ? room.name : ''}
                    </div>
                </small>
            </div>
        </div>
    );
};

export default TerminalHeader;
